import { CourseAssignment } from './course-assignments';
import { createErrorMessageTypeGuard } from './createErrorMessageTypeGuard';
import { makeRequest, CommonRequestOptions } from './makeRequest';

export type TeamCourseAssignment = CourseAssignment & {
   assignee_teamid: number;
};

export type GetTeamCourseAssignmentsOptions = CommonRequestOptions & {
   page?: number;
   pageSize?: number;
};

type GetTeamCourseAssignmentsResult = {
   course_assignments: TeamCourseAssignment[];
   hasMore: boolean;
};

export function getTeamCourseAssignments(
   teamid: number,
   { page, pageSize, ...common }: GetTeamCourseAssignmentsOptions = {}
): Promise<GetTeamCourseAssignmentsResult> {
   return makeRequest('get', `/teams/${teamid}/course_assignments`, {
      ...common,
      query: {
         page,
         pageSize,
      },
   });
}

type GetTeamCourseAssignmentsErrorCode = 'teams.team_not_found';
getTeamCourseAssignments.errorMessages =
   createErrorMessageTypeGuard<GetTeamCourseAssignmentsErrorCode>();
